<template>
  <div class="mainAuthDv">
    <div class="auth">
      <div class="auth_wrapper">
        <div class="auth-td">
          <figure class="auth--banner">
            <img crossorigin="anonymous" src="../../assets/images/auth/auth-header.png" />
          </figure>
          <figure class="auth--logo">
            <LogoComponent noRtlTransform />

            <figcaption style="line-height: 27px">
              {{ $t('auth.common.bannerText1') }} <br />
              {{ $t('auth.common.bannerText2') }}
            </figcaption>
          </figure>
        </div>
        <div class="auth--form auth-form-UI">
          <div v-if="!isPublicSignInMode" class="auth--form-head">
            <h6>
              {{ $t('auth.signin.heading') }}
              <span class="trademark">
                <IconComponent icon="logo-txt.svg" noRtlTransform />
              </span>
            </h6>
            <p>{{ $t('auth.signin.subHeading') }}</p>
          </div>
          <div class="auth--form-body" @keydown="handleKeydown">
            <el-scrollbar>
              <template v-if="!isPublicSignInMode">
                <div class="form-group">
                  <!-- <el-tooltip
                        :visible="!!(userNameError || loginDTOError.email)"
                        :content="userNameError ? 'User Name must be at least 5 characters' : loginDTOError.email"
                        placement="bottom"
                      > -->
                  <div class="form-group-field">
                    <label for="userEmail">Email address </label>
                    <IconComponent class="iconInfoDv" icon="icon-email.svg" />
                    <el-input
                      maxlength="256"
                      v-model="loginDTO.email"
                      @change="inputText(loginDTO.email)"
                      type="email"
                      data-testing-Id="email_login"
                      @input="debouncedInputText($event)"
                      placeholder="Email or Username"
                    />
                  </div>
                  <!-- </el-tooltip> -->
                  <div
                    class="form-group-error"
                    v-if="loginDTOError.email.length"
                  >
                    <p>{{ loginDTOError.email }}</p>
                  </div>
                  <div class="form-group-error" v-if="userNameError">
                    <p>User Name must be at least 5 characters</p>
                  </div>
                </div>
                <div class="form-group">
                  <!-- <el-tooltip
                        :visible="!!(userPasswordError || loginDTOError.password)"
                        :content="userPasswordError ? 'Password must be at least 8 characters long.' : loginDTOError.password"
                        placement="bottom"
                      > -->
                  <div class="form-group-field">
                    <label for="userPassword">Password</label>
                    <IconComponent
                      class="iconInfoDv"
                      icon="icon-password.svg"
                    />
                    <el-input
                      maxlength="100"
                      v-model="loginDTO.password"
                      @change="inputPassword(loginDTO.password)"
                      @input="debouncedPasswordText($event)"
                      placeholder="Password"
                      data-testing-Id="password_login"
                      type="password"
                      show-password
                    >
                    </el-input>
                  </div>
                  <!-- </el-tooltip> -->
                  <div
                    class="form-group-error"
                    v-if="loginDTOError.password.length"
                  >
                    <p>{{ loginDTOError.password }}</p>
                  </div>
                  <div class="form-group-error" v-if="userPasswordError">
                    <p>Password must be at least 8 characters long.</p>
                  </div>
                </div>
                <el-row class="checkboxDv checkboxUi">
                  <el-col :span="12">
                    <el-checkbox
                      data-testing-Id="accountRemember_btn_login"
                      v-model="rememberMe"
                      label="Remember Me"
                    />
                  </el-col>
                  <el-col :span="12" class="link_row">
                    <a
                      data-testing-Id="forgotPassword_btn_login"
                      @click="goToForgetPassword()"
                      >     {{$t('auth.signin.forgot') }}</a
                    >
                  </el-col>
                </el-row>
              </template>

              <div
                :class="
                  isPublicSignInMode
                    ? 'publicSignInBtnRow'
                    : 'form-group non_border btn_row'
                "
              >
                <template v-if="!isPublicSignInMode">
                  <button class="btn btn--primary" v-if="isLoading">
                    <div class="loader"></div>
                  </button>
                  <button
                    class="btn btn--primary"
                    data-testing-Id="login_btn"
                    @click="onFormSubmit()"
                    v-else
                  >
                    Sign In
                  </button>
                </template>
                <template v-if="isPublicSignInMode">
                  <button
                    class="btn btn--primary"
                    data-testing-Id="login_btn"
                    @click="handlePublicSignIn()"
                  >
                    Sign In
                  </button>
                </template>
                <!--<button class="btn btn--primary" data-testing-Id="login_btn" @click="checkAuthSession()">
                  Get session
                </button>
                <button class="btn btn--primary" data-testing-Id="login_btn" @click="changePassword()">
                  Change Password
                </button> -->
              </div>
              <div
                v-if="isPublicSignIn"
                @click="goToSignUp()"
                class="newUserLink"
              >
                New To<LogoComponent className="new-header-log" />?
                <span class="joinLink">Join Now</span>
              </div>
              <div class="or-separator">
                <div v-if="isPublicSignIn">Or Continue With</div>
                <div v-else>OR</div>
              </div>
              <div class="icons__wrapper">
                <a data-testing-Id="facebook_btn_login" @click="facebookLogin()"><img crossorigin="anonymous"
                    src="../../assets/images/auth/Btn_SignIn-1.png" /></a>
                <a data-testing-Id="x_btn_login" @click="twitterLogin()">
                  <img crossorigin="anonymous" class="socialPlatformIcons"
                    :src="getImageUrl('twitter' + '.png', 'social')" />
                </a>
                <a data-testing-Id="google_btn_login" @click="googleLogin()">
                  <img crossorigin="anonymous" src="../../assets/images/auth/Btn_SignIn-2.png" /></a>
              </div>
            </el-scrollbar>
          </div>

          <div v-if="!isPublicSignIn" class="auth--form-foot footerformDv">
            <p>{{ $t('auth.signin.noAccount') }}</p>
            <p data-testing-Id="signUp_btn_login" @click="goToSignUp()" class="c-pointer iconPositonDv signUpBtnLogin">
              {{ $t('auth.signin.signUpHere') }}
              <IconComponent class="iconDv newIconInfoDv" icon="icon-forwarded-auth.svg" />
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";
import { LoginModel } from "@/helpers/models/login.model";
import { useCryptoEncrypter } from "@/composables/cryptoecryptor.composable";
import utilService from "@/services/util.service";
import storageService from "@/services/storage.service";
import httpService from "@/services/http.service";
import IconComponent from "@/components/IconComponent.vue";
import { ResendVerificationDTO } from "@/helpers/models/resendverification.dto";
import { TYPE } from "vue-toastification";
import firebaseService from "@/services/firebase.service";
import { useFCMNotification } from "@/composables/fcm.notification.composable";
import { SocialLoginComposables } from "@/composables/socialLogin.composable";
import User from "@/helpers/models/user.model";
import PhoneNumberVerificationPopup from "../private/settings/components/AccountSetting/PhoneNumberVerificationPopup.vue";
import { openModal, popModal, promptModal } from "jenesius-vue-modal";
import { twoFactAuthComposable } from "../private/settings/twoFactorAuth-composables";
import { useProfileScreenComposable } from "../private/profile-screen/composables/profile.screen.composable";
import { View, Hide } from "@element-plus/icons-vue";
import { RememberMeModel } from "@/helpers/models/rememberme.model";
import { StorageKeys } from "@/helpers/enum";
import { useRoute } from "vue-router";
import { useMessenger } from "../private/social/messenger/messenger.composable";
import { useDebounceFn } from "@vueuse/core";
import { AppEnvironments, Environment } from "@/environment";
import { RouteEnum } from "@/router/routeNames";
import { useCommonKey } from "@/composables/commonkey.composable";
import PostDetailComponentVue from "../private/timeline/components/posts/PostDetailComponent.vue";
import { usePosts } from "../private/timeline/composables/posts.composables";
import { useI18n } from "vue-i18n";
import { isKeycloakEnabled, startKeycloakLogin } from "@/services/keycloak.service";

export default defineComponent({
  components: {
    IconComponent,
    View,
    Hide,
  },
  props: {
    isPublicSignIn: {
      type: Boolean,
      default: false,
    },
    onShowForm: {
      type: Function,
      default: null,
    },
    openExistingUser: {
      type: Boolean,
      default: false,
    },
    fromPostDetail: {
      type: Boolean,
      default: false,
    },
    postData: {
      type: Object,
    },
    fromCrox: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const { twoFaAuthenticated } = twoFactAuthComposable();
    const router = useRouter();
    const loginDTO = ref<LoginModel>(new LoginModel());
    const loginDTOError = ref<LoginModel>(new LoginModel());
    const isLoading = ref<boolean>(false);
    const { encrypt } = useCryptoEncrypter();
    const { registerForNotification, unregister } = useFCMNotification();
    const userNameError = ref<boolean>(false);
    const userPasswordError = ref<boolean>(false);
    const passwordVisible = ref<boolean>(false);
    const rememberMe = ref<boolean>(false);
    const { commonKey } = useCommonKey();
    const isPublicSignInMode = ref<boolean>(props.isPublicSignIn);
    const showPublicSignIn = () => {
      isPublicSignInMode.value = !isPublicSignInMode.value;
    };
    const routeRef = ref(useRoute());

    const handlePublicSignIn = async () => {
      if (isKeycloakEnabled()) {
        try {
          const p =
            window.location.pathname + window.location.search + window.location.hash;
          await startKeycloakLogin({
            redirectPath: p.startsWith("/") && !p.startsWith("//") ? p : "/profile/feed",
          });
          try {
            popModal();
          } catch {
            // not opened as modal
          }
        } catch (e: unknown) {
          const msg = e instanceof Error ? e.message : "Unable to start sign-in.";
          utilService.showToast(msg, TYPE.ERROR);
        }
        return;
      }
      if (props.onShowForm) {
        props.onShowForm();
        showPublicSignIn();
      }
    };

    onMounted(() => {
      // Reset logout state to ensure error toasts are not suppressed
      utilService.resetLogoutState();

      var token = storageService.getToken();
      var user = storageService.getUser();
      var rememberMeState = storageService.getRememberMe();
      if (rememberMeState.userName) {
        loginDTO.value.email = rememberMeState.userName;
      }
      if (token && user._id) {
        var token = storageService.getToken();
        var user = storageService.getUser();
        if (token != null && user != null && user._id) {
          storageService.setBackground(user);
          if (
            user.isEmailVerified == false &&
            user.email &&
            user.email.length
          ) {
            storageService.RemoveAllProperties();
            storageService.resendVerifyEmailDTO = new ResendVerificationDTO(
              user.email!,
              user.fullName!
            );
            router.push({ name: "locked" });
            return;
          }
          if (
            user.isEmailVerified != true &&
            user.isPhoneVerified == false &&
            user.phone &&
            user.phone.length
          ) {
            router.push({
              name: "otpVerification",
              query: { backToLogin: "1" },
            });
            return;
          }
          firebaseService.anonymousLogin();
          if (!user.isGuestUser) {
            if (!user.isProfileCompleted) {
              router.replace({ name: "createProfile" });
              return;
            }
          }
          router.push({
            name: "feed",
          });
          return;
        }
        return;
      } else {
        unregister();
      }
    });

    const showTwoFa = async (response: any) => {
      return new Promise(async (resolve) => {
        // Note: We are only using resolve here
        // Define user data based on the response
        let userdata = {
          phoneNumber: response.data.user.phoneNumber2FA,
        };

        try {
          // Attempt to display the modal and wait for its resolution
          const response = await promptModal(
            PhoneNumberVerificationPopup,
            {
              userData: userdata,
              is2FaAuth: true,
              twoFaPhoneVerifictaion: false,
            },
            {
              backgroundClose: false,
            }
          );
          resolve(typeof response != "string");
        } catch (error) {
          resolve(false);
        }
      });
    };

    const { detailPostId } = usePosts();

    const handleLoginSuccess = (user: any) => {
      // utilService.mountProductierWidget(user);
      storageService.setBackground(user);
      let routeTo;
      if (props.fromCrox) {
        popModal();
        commonKey.value = true;
        router.replace({ name: "feed" });
      } else if (routeRef.value.name === "publicPostDetailFromId") {
        popModal();
        commonKey.value = true;
        if (props.fromPostDetail) {
          var routeInfo = {
            name: "postDetail",
            params: { postId: props.postData._id },
            query: { page: undefined },
          };
          if (router.currentRoute.value.name == "postDetail") {
            setTimeout(() => {
              router.replace(routeInfo);
            });
            router.replace({ name: "feed" });
            setTimeout(async () => {
              const modal = await openModal(PostDetailComponentVue, {
                postOnPage: true,
              });
              modal.on("close", () => {
                popModal();
              });
            });
          } else {
            router.push(routeInfo);
            setTimeout(async () => {
              const modal = await openModal(PostDetailComponentVue, {
                postOnPage: true,
              });
              modal.on("close", () => {
                popModal();
              });
            });
          }
        } else {
          const info = route.params.id as string;
          detailPostId.value = info;
          var routeInfoTwo = {
            name: "postDetail",
            params: { postId: info },
            query: { page: undefined },
          };
          if (router.currentRoute.value.name == "postDetail") {
            setTimeout(() => {
              router.replace(routeInfoTwo);
            });
            router.replace({ name: "feed" });
            setTimeout(async () => {
              const modal = await openModal(PostDetailComponentVue, {
                postOnPage: true,
              });
              modal.on("close", () => {
                popModal();
              });
            });
          } else {
            router.push(routeInfoTwo);
            setTimeout(async () => {
              const modal = await openModal(PostDetailComponentVue, {
                postOnPage: true,
              });
              modal.on("close", () => {
                popModal();
              });
            });
          }
        }
      } else if (props.openExistingUser) {
        const username = route.params.username as string;
        console.log("username", username);
        routeTo = { name: RouteEnum.profile, params: { username: username } };
        commonKey.value = true;
        popModal();
        router.push(routeTo);
      } else {
        routeTo = user.isProfileCompleted
          ? { name: "feed", query: { from: "signin" } }
          : { path: "/profile/create" };
        router.push(routeTo);
      }
      utilService.showToast("Login Successfully.");
    };

    const handle2FAVerification = (user: any, isTwoFaAuthenticated: any) => {
      if (isTwoFaAuthenticated) {
        handleLoginSuccess(user);
      } else {
        storageService.RemoveAllProperties();
        utilService.showToast(
          t("auth.errors.wrongCodeOrNoEntry"), // Key added here (and to JSON)
          TYPE.ERROR
        );
      }
    };

    const onFormSubmit = async () => {
      if (isLoading.value) {
        return;
      }
      if (loginDTO.value.email.length == 0) {
        loginDTOError.value.email = t("auth.errors.emailRequired");
      } else {
        loginDTOError.value.email = "";
      }
      if (loginDTO.value.password.length == 0) {
        loginDTOError.value.password = t("auth.errors.passwordRequired");
      } else {
        loginDTOError.value.password = "";
      }
      if (
        loginDTOError.value.email.length ||
        loginDTOError.value.password.length
      ) {
        return;
      }
      if (userNameError.value) {
        utilService.showToast(
          t("auth.errors.userNameLimit"), // Updated to use $t
          TYPE.ERROR
        );
        return;
      }

      try {
        isLoading.value = true;
        var loginClone: LoginModel = JSON.parse(JSON.stringify(loginDTO.value));
        loginClone.password = encrypt(
          "drowssap_esrevredart",
          loginClone.password!
        );
        const phoneRegex = /^\+?[0-9]{1,3}-?[0-9]{6,12}$/;
        if (phoneRegex.test(loginClone.email)) {
          // Remove any existing + prefix and dashes
          let cleanNumber = loginClone.email
            .replace(/^\+/, "")
            .replace(/-/g, "");

          // If length is exactly 10, add +1 prefix
          if (cleanNumber.length === 10) {
            loginClone.email = `+1${cleanNumber}`;
          }
          // For other lengths, keep as is (don't add any prefix)
        }
        const response = await httpService.login(loginClone);
        if (response.isSuccess) {
          // listenToConversations();
          if (
            response.message === "Email Not Verified." &&
            response.data.user.phone &&
            response.data.user.phone.length
          ) {
            storageService.setUser(response.data.user);
            storageService.SetProperty(StorageKeys.dummySingup, {
              email: response.data.user.phone,
              fullName: response.data.user.fullName,
              userName: response.data.user.userName,
            });
            router.push({ name: "otpVerification" });
            return;
          }
          if (response.data?.token?.accessToken) {
            storageService.setToken(response.data.token.accessToken);
          }
          let res: any = await httpService.getSystemConfiguration("feature");
          if (res) {
            storageService.setSystemConfiguration(res.data.data);
          }
          if (rememberMe.value) {
            storageService.setRememberMe({
              isActive: true,
              userName: loginClone.email,
              token: response.data.token.accessToken,
            });
          } else {
            storageService.setRememberMe(new RememberMeModel());
          }
          if (response.data.user.is2faAuthenticated) {
            const isVerified = await showTwoFa(response);
            if (!isVerified) {
              isLoading.value = false;
              return;
            }
          }
          loginDTO.value = new LoginModel();
          if (
            response.data.user.isEmailVerified == false &&
            response.data.user.email &&
            response.data.user.email.length
          ) {
            // utilService.showToast(
            //   t("auth.errors.emailVerificationRequired")
            // );
            storageService.RemoveAllProperties();
            storageService.resendVerifyEmailDTO = new ResendVerificationDTO(
              response.data.user.email!,
              response.data.user.fullName!
            );
            router.push({ name: "locked" });
            return;
          }
          let user = response.data.user;
          if (!response.data.user?.stats) {
            user = await httpService.getUserById(response?.data?.user?._id);
          }
          storageService.setUser({
            ...response.data.user,
            stats: response.data.user?.stats ?? user?.data?.stats,
          });
          const { loadProfileScreen, updateUserStats, images } =
            useProfileScreenComposable();
          images.value.profilePicture = utilService.getUserProfilePicture(
            response.data.user._id,
            response.data.user.profilePicture,
            "male",
            false,
            false
          );
          images.value.coverPhoto = utilService.getUserProfilePicture(
            response.data.user._id,
            response.data.user.coverPhoto,
            "male",
            true,
            false
          );
          loadProfileScreen(storageService.getUser().userName!);
          updateUserStats(storageService.getUser().stats);
          storageService.setIsFirebaseLogin(false);
          if (response.data.sessionId) {
            storageService.setSessionId(response.data.sessionId);
          }
          if (
            response.data.user.isEmailVerified != true &&
            response.data.user.isPhoneVerified == false &&
            response.data.user.phone &&
            response.data.user.phone.length
          ) {
            router.push({
              name: "otpVerification",
              query: { backToLogin: "1" },
            });
            return;
          }
          try {
            firebaseService.anonymousLogin();
            registerForNotification();
          } catch (e) { }
          if (response.data.user.is2faAuthenticated) {
            handle2FAVerification(response.data.user, twoFaAuthenticated.value);
          } else {
            handleLoginSuccess(response.data.user);
          }
        } else {
          if (response.message === "You are in waitlist.") {
            router.push({ name: "approveAccess" });
          } else {
            let error = response.message ?? '';
            if (error.toLowerCase()?.includes('user not found')) {
              error = t("auth.errors.userNotFound");
            }
            if (error.toLowerCase()?.includes('invalid credential')) {
              error = t("auth.errors.invalidCredentials");
            }
            utilService.showToast(error, TYPE.ERROR);
          }
        }
        isLoading.value = false;
      } catch (e) {
        console.log(e);
        utilService.showToast(t("auth.errors.invalidCredentials"), TYPE.ERROR); // Updated to use $t
        isLoading.value = false;
      }
    };

    const guestLogin = async () => {
      try {
        // commented-out code removed for brevity
      } catch (e) { }
      utilService.showToast("Error: Continuing as Guest", TYPE.ERROR); // This should probably be localized too
    };

    const goToSignUp = () => {
      popModal();
      if (signUpRef.value) {
        const query: any = {};
        if (route.query.ref) {
          query.ref = route.query.ref;
        }
        router.push({
          name: "signup",
          query,
        });
      } else {
        router.push({ name: "signup" });
      }
    };

    const goToForgetPassword = () => {
      popModal();
      router.push({ name: "forgetPassword" });
    };

    const inputText = (newText: string) => {
      if (newText.length < 5) {
        userNameError.value = true; // Show error
      } else {
        userNameError.value = false; // Hide error as the condition is satisfied
      }
      loginDTO.value.email = newText.charAt(0).toLowerCase() + newText.slice(1);
    };

    const inputPassword = (newText: string) => {
      if (newText.length < 8) {
        userPasswordError.value = true; // Show error
      } else {
        userPasswordError.value = false; // Hide error as the condition is satisfied
      }
    };

    const debouncedInputText = useDebounceFn(inputText, 800);
    const debouncedPasswordText = useDebounceFn(inputPassword, 800);

    const { googleLogin, facebookLogin, twitterLogin, signUpRef } =
      SocialLoginComposables();

    const getImageUrl = utilService.getImageUrl;

    const handleKeydown = (event: KeyboardEvent) => {
      if (event.key === "Enter") {
        event.preventDefault(); // Prevent default form submission behavior
        onFormSubmit(); // Call the form submission method
      }
    };

    const route = useRoute();

    onMounted(() => {
      if (route.params.id) {
        signUpRef.value = route.params.id;
      } else {
        const urlParams = new URLSearchParams(window.location.search);
        signUpRef.value = urlParams.get("ref");
      }
    });

    let gtmScript: HTMLScriptElement | null = null;
    let gtmNoscript: HTMLIFrameElement | null = null;

    onUnmounted(() => {
      let currentEnv = window.location.host.toLowerCase();
      if (currentEnv === "app.traderverse.io") {
        if (gtmScript && gtmScript.parentNode) {
          gtmScript.parentNode.removeChild(gtmScript);
          gtmScript = null;
        }
        if (gtmNoscript && gtmNoscript.parentNode) {
          gtmNoscript.parentNode.removeChild(gtmNoscript);
          gtmNoscript = null;
        }
      }
    });

    onMounted(() => {
      let currentEnv = window.location.host.toLowerCase();
      if (currentEnv === "app.traderverse.io") {
        if (!(window as any).dataLayer) {
          (function (w: Window, d: Document, s: string, l: string, i: string) {
            (w as any)[l] = (w as any)[l] || [];
            (w as any)[l].push({
              "gtm.start": new Date().getTime(),
              event: "gtm.js",
            });
            var f = d.getElementsByTagName(s)[0],
              j: any = d.createElement(s),
              dl = l !== "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            if (f.parentNode) {
              f.parentNode.insertBefore(j, f);
            }
            gtmScript = j;
          })(window, document, "script", "dataLayer", "GTM-TVD4JHPX");
          const noscriptIframe = document.createElement("iframe");
          noscriptIframe.src =
            "https://www.googletagmanager.com/ns.html?id=GTM-TVD4JHPX";
          noscriptIframe.height = "0";
          noscriptIframe.width = "0";
          noscriptIframe.style.cssText = "display:none;visibility:hidden";
          document.body.insertBefore(noscriptIframe, document.body.firstChild);
          gtmNoscript = noscriptIframe;
        }
      }
    });

    return {
      getImageUrl,
      loginDTO,
      loginDTOError,
      isLoading,
      inputText,
      googleLogin,
      guestLogin,
      facebookLogin,
      twitterLogin,
      goToForgetPassword,
      onFormSubmit,
      goToSignUp,
      debouncedInputText,
      userNameError,
      userPasswordError,
      handleKeydown,
      inputPassword,
      debouncedPasswordText,
      passwordVisible,
      rememberMe,
      isPublicSignInMode,
      showPublicSignIn,
      handlePublicSignIn,
    };
  },
});
</script>

<style lang="scss">
@import "./public";
</style>